export const resources = {
  en: {
    translation: {
      title: 'Revolutionize the creative experience powered by AI',
      description:
        "By merging cutting-edge AI capabilities with intuitive design, we're crafting a new era of creation where ideas flourish effortlessly and innovation becomes second nature.",
      pricing: 'Pricing',
      login: 'Login',
      addToChrome: 'Add to Chrome',
    },
  },
  zh: {
    translation: {
      title: '由AI驱动，革新创意体验',
      description: '通过将尖端AI功能与直观设计相结合，我们正在开创一个创意自然流露、创新成为本能的新时代。',
      pricing: '定价',
      login: '登录',
      addToChrome: '添加至Chrome',
    },
  },
  fr: {
    translation: {
      title: "Révolutionnez l'expérience créative propulsée par l'IA",
      description:
        "En fusionnant les capacités de pointe de l'IA avec un design intuitif, nous créons une nouvelle ère de création où les idées s'épanouissent sans effort et l'innovation devient naturelle.",
      pricing: 'Tarification',
      login: 'Connexion',
      addToChrome: 'Ajouter à Chrome',
    },
  },
}
